import React from 'react'

function AttachTagItemHeader() {
    return (
        <thead className='thead-light AttachTagItemHeader'>
            <tr>
                <th className='Barcode'>Barcode</th>
                <th className='LabelPreview'>SKU</th>
                <th className='TrackingCarrier'>Size</th>
                <th className='CreatedDate'>Tên lô</th>
                <th className='LabelNote'>Thời gian gắn tag mác</th>
                <th className='LabelType'>Người gắn tag mác</th>
            </tr>
        </thead>
    )
}

export default AttachTagItemHeader
